export default __webpack_public_path__ + "static/media/Energy & utilities.1f203bfa.svg";